<template>
  <div class="loginFrom">
    <!-- <div class="headCon">
      <div class="text1">欢迎登录东智云</div>
      <div class="text2">简单高效DIY，成就新一代“工业极客”</div>
    </div> -->
    <div class="code-image" @click="isPcFnc" :class="{ 'is-pc': !isPc }"></div>

    <div class="loginFrom-content" v-show="relTenantNumFlag">
      <loginCode v-if="!isPc" />

      <el-tabs
        v-model="loginType"
        @keydown.enter.native="loginFun('single')"
        v-if="isPc"
      >
        <el-tab-pane label="密码登录" name="account">
          <accountFrom ref="accountFrom" />
        </el-tab-pane>
        <el-tab-pane label="短信登录" name="phone">
          <phoneFrom @sendImageCode="sendImageCode" ref="phoneFrom" />
        </el-tab-pane>
      </el-tabs>
      <!--登录-->
      <el-button
        v-if="isPc"
        class="submit-button"
        type="primary"
        size="large"
        style="height: 40px"
        :loading="loading"
        block
        @click="loginFun('single')"
        >登录</el-button
      >

      <!--注册-->
      <span class="loginFrom-setting" v-if="isPc">
        <span @click="goToResetpwd">忘记密码</span>
        <span @click="goToRegister">新用户注册</span>
      </span>
      <div></div>
    </div>

    <!--多租户选择-->
    <div class="select-tenat-wrap" v-show="!relTenantNumFlag">
      <div class="tenat-header">
        <i class="el-icon-back" @click="backFun"></i>
        <span class="tc f16">选择登录身份</span>
      </div>
      <div class="select-tenat-content">
        <el-form
          ref="ruleForm"
          :model="formData"
          :rules="ruleForm"
          label-width="0"
          id="components-form-demo-normal-login"
          class="login-form"
        >
          <el-form-item prop="tenetUserId">
            <el-select
              v-model="formData.tenetUserId"
              placeholder="请选择身份"
              v-if="tenetUserList.length > 5"
            >
              <el-option
                v-for="(item, index) in tenetUserList"
                :value="item.tenantId"
                :key="index"
              >
                {{ item.tenantName }}({{ item.tenantId }})
              </el-option>
            </el-select>

            <el-radio-group v-model="formData.tenetUserId" v-else>
              <el-radio
                v-for="item in tenetUserList"
                :label="item.tenantId"
                :key="item.tenantId"
                :style="radioStyle"
              >
                {{ item.tenantName }}({{ item.tenantId }})
              </el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>

        <!-- 登录按钮 -->
        <el-button
          class="submit-button"
          type="primary"
          size="large"
          :loading="loading"
          block
          @click="loginFun('multiple')"
          >进入</el-button
        >
      </div>
    </div>
    <get-image-code
      :visible.sync="imageCodeStatus"
      :loading="confirmLoading"
      @callback="callback"
    />
  </div>
</template>

<script>
import loginMixins from "../mixins";
import accountFrom from "./accountFrom";
import phoneFrom from "./phoneFrom";
import * as loginApi from "@/util/api";
import { encryptByDES, clearSessLocal } from "@/util";
import { setToken, removeToken } from "@/util/auth";
import getImageCode from "./getImageCode";
import loginCode from "./loginCode";

const MULTIPLE_CODE = 406;

export default {
  components: {
    accountFrom,
    phoneFrom,
    getImageCode,
    loginCode,
  },

  mixins: [loginMixins],
  data() {
    return {
      isPc: true,
      imageCodeStatus: false,
      radioStyle: {
        display: "block",
        height: "30px",
        lineHeight: "30px",
      },
      loginType: "account", // 默认账号登录
      relTenantNumFlag: true,
      formData: {
        tenetUserId: "",
      },
      ruleForm: {
        tenetUserId: [
          { required: true, message: "登录身份不能为空！", trigger: "change" },
        ],
      },
      loading: false,
      confirmLoading: false,
    };
  },
  computed: {
    tenetUserList() {
      return this.$store.state.cache.tenetUserList;
    },
  },
  watch: {
    "formData.tenetUserId"(val) {
      if (val) {
        this.$store.commit("setCurrentTenetId", val);
      }
    },
  },
  methods: {
    //二维码登录
    isPcFnc() {
      this.isPc = !this.isPc;
    },
    callback(data) {
      this.confirmLoading = true;
      this.$refs.phoneFrom.sendCode(true, data);
    },
    sendImageCode(data) {
      this.imageCodeStatus = data;
      this.confirmLoading = false;
    },
    backFun() {
      this.relTenantNumFlag = true;
    },
    // 忘记密码
    resetPassFun() {},
    /*
     * 当用户关联多个租户 进入选择用户身份页面； 当仅关联一个租户 直接进入首页;
     * @param tenantId 当选择租户了才传  code === '406' 表示多租户
     * 用userName 掉接口生产一个密钥key 然后key在拼接密码 一起登录
     * encryptByDES 登录密码和base64加密
     */
    loginFun(str) {
      if (this.loginType === "phone") {
        this.$refs.phoneFrom.$refs.form.validateField("phone", (err) => {
          if (!err) {
            //  this.loginHandler(str); // 登陆处理逻辑
            this.loginHandler(str, "phone"); // 登陆处理逻辑
          }
        });
      } else {
        // 校验
        this.$refs.accountFrom.$refs.ruleForm.validate((valid) => {
          if (!valid) {
            return;
          }
          this.loginHandler(str); // 登陆处理逻辑
        });
      }
    },
    /*
        str 是否是多租户
        loginType 登录方式
      */
    async loginHandler(str, loginType) {
      const { email, password } = this.$refs.accountFrom.formData;
      const params = new FormData();
      let flag = true;
      // 选择第二步骤
      if (str === "multiple") {
        this.$refs.ruleForm.validate((valid) => {
          flag = valid;
          if (!valid) {
            return;
          }
          params.append("tenantId", this.formData.tenetUserId);
        });
      } else {
        this.$store.commit("setTenetUserList", []);
        this.$store.commit("setCurrentTenetId", "");
      }
      if (!flag) {
        return;
      }
      try {
        this.loading = true;
        let ssh_key;
        if (loginType === "phone") {
          const { phone, code } = this.$refs.phoneFrom.form;
          // 第一个 密钥
          ssh_key = await loginApi.getKey({ username: phone });
          params.append("grant_type", "sms");
          params.append("mobile", phone);
          params.append("smsVerification", code);
        } else {
          // 第一个 密钥
          ssh_key = await loginApi.getKey({ username: email });
          params.append("grant_type", "password");
          params.append("username", email);
          params.append("password", encryptByDES(password, ssh_key.data));
        }
        params.append("isSerialize", true);
        if (ssh_key.code !== 0) {
          this.loading = false;
        }
        // 第二个 登陆接口
        const login_data = await loginApi.login(params);
        if (login_data.code === MULTIPLE_CODE) {
          this.relTenantNumFlag = false;
          this.tenetUserId = "";
          this.formData.tenetUserId = login_data.data[0].tenantId;
          this.$store.commit("setTenetUserList", login_data.data || []);
          this.$store.commit("setCurrentTenetId", this.formData.tenetUserId);
          this.loading = false;
        } else if (login_data.code === 0) {
          removeToken(); // 清空token
          clearSessLocal(true, true); // 清空sess local
          setToken(login_data.data.accessToken, login_data.data.tokenType);
          // 第三个 用户信息
          const user_info = await loginApi.getCurUser();
          // 自己系统上面的登录回调 记录用户的登录信息
          await loginApi.pushLoginInfo(params);
          if (user_info.code === 0 && user_info.data.uid) {
            this.$store.commit("setUserInfo", user_info.data);
            // 第四个 获取系统id
            const geek_info = await loginApi.getSystemId();
            console.log(geek_info);
            if (geek_info.code === 0) {
              this.$store.commit("setCurrentSystemId", user_info.data.id);
              const fromUrl = this.$route.query.fromUrl || "";
              // 如果有 fromUrl 不走公有云 直接走fromUrl 配合其他项目
              if (
                fromUrl &&
                (fromUrl.indexOf("http") !== -1 ||
                  fromUrl.indexOf("https") !== -1) &&
                fromUrl.indexOf("/web-admin") === -1 &&
                fromUrl.indexOf("/web-consumer-center") === -1
              ) {
                window.location.href = fromUrl;
              } else {
                const codes = user_info.data.roleRefDtoList.map(
                  (role) => role.code
                );
                if (
                  codes.indexOf("web-consumer-center_admin") >= 0 ||
                  codes.indexOf("web-consumer-center_engineer") >= 0
                ) {
                  window.location.href = "/web-consumer-center";
                } else if (codes.indexOf("web-admin_register-user") >= 0) {
                  removeToken(); // 清空token
                  clearSessLocal(true, true); // 清空sess local
                  this.loading = false;
                  this.$message.warning("注册用户请在APP登录");
                } else {
                  window.location.href = "/web-admin";
                }
              }
            } else {
              this.loading = false;
            }
          } else {
            removeToken(); // 清空token
            clearSessLocal(true, true); // 清空sess local
            this.loading = false;
          }
        } else {
          this.loading = false;
          this.$message.warning(login_data.msg);
        }
      } catch (err) {
        removeToken(); // 清空token
        clearSessLocal(true, true);
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped lang="less">
.loginFrom {
  .submit-button {
    display: block;
    width: 100%;
    border-radius: 2px;
    background-color: @c-theme;
    border: none;
    transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
    border-radius: 8px;
    // &:hover {
    //   // background-color: #102C99;
    //   // border-color: #102C99;
    // }
    // &:active {
    //   // background-color: #031762;
    //   // border-color: #031762;
    // }
  }

  margin: 20px 107px 20px 0;
  // margin-top: -1%;
  .headCon {
    .text1 {
      font-size: 48px;
      font-weight: normal;
      line-height: 66px;
      margin-bottom: 20px;
    }
    .text2 {
      font-size: 24px;
      font-weight: normal;
      line-height: 34px;
      margin-bottom: 35px;
    }
  }
  .comStyle {
    box-shadow: 0 4px 10px 0 rgba(4, 12, 44, 0.25);
    border: 1px solid @c-bg-1;
  }
  .loginFrom-content {
    width: 400px;
    height: 460px;
    background: @c-bg-5;
    padding: 0 25px;
    border-radius: 4px;
    box-sizing: border-box;

    .comStyle;

    /deep/ .el-tabs {
      &__header {
        margin-bottom: 40px;
      }
      &__nav-scroll {
        display: flex;
        justify-content: left;
      }

      &__active-bar {
        background-color: @tabs-item-is-active;
        width: 26px !important;
        height: 6px;
        border-radius: 3px;
        left: 27px;
      }

      &__nav-wrap::after {
        height: 0;
        background-color: #e8e8e8;
      }

      &__item {
        height: auto;
        line-height: 2;
        padding-top: 20px;
        padding-bottom: 12px;
        font-size: 14px;
        color: @c-text-rgb;
        &.is-active {
          color: #000;
          font-size: 20px;
        }
      }

      .el-form {
        &-item {
          margin-bottom: 24px;
        }

        .el-input__inner {
          height: 40px;
          border-radius: 8px;
          border: 1px solid @c-bg-rgb2;
        }
      }
    }

    .loginFrom-setting {
      display: inline-block;
      height: 52px;
      line-height: 52px;
      float: right;
      cursor: pointer;
      user-select: none;
      font-size: 14px;
      color: @c-text-rgb;
      & > span {
        padding-left: 30px;
      }
      & > span:hover {
        color: @c-primary;
      }
    }
  }
  .select-tenat-wrap {
    width: 440px;
    height: 354px;
    background: @c-bg-5;
    border-radius: 4px;
    .comStyle;
    .tenat-header {
      height: 56px;
      border-bottom: 1px solid @c-bg-1;
      line-height: 56px;
      font-weight: bolder;
      padding: 0 40px 0 0;
      display: flex;
      text-align: center;

      span {
        flex: 1;
        font-size: 16px;
      }
      i {
        line-height: 56px;
        width: 40px;
        cursor: pointer;
        font-size: 20px;
        &:hover {
          color: @c-primary;
        }
      }
    }
    .select-tenat-content {
      padding: 40px 40px 20px;

      /deep/ .el-form {
        &-item {
          margin-bottom: 24px;
        }

        .el-radio {
          &__label {
            font-size: 12px;
          }

          &__input {
            &.is-checked .el-radio__inner {
              border-color: @c-primary;
              background: @c-primary;
            }

            &.is-checked + .el-radio__label {
              color: inherit;
            }
          }
        }
      }
    }
  }
  .code-image {
    position: absolute;
    top: 0;
    right: 0;
    display: inline-block;
    width: 50px;
    height: 50px;
    background: url("~@img/login/code.svg") no-repeat center center;
    background-size: cover;
    cursor: pointer;
    margin: 5px 5px 0 0;
  }
  .is-pc {
    background: url("~@img/login/pc.svg") no-repeat center center;
  }
  position: relative;
}
@media screen and (max-width: 992px) {
  .loginFrom {
    margin: 0 20px;
    width: 100%;
    box-sizing: border-box;
  }
  .login-header {
    display: none;
  }
  .loginFrom .loginFrom-content {
    height: 350px;
    width: 100%;
  }
}
// @media screen and (max-width: 1440px) {
//   .loginFrom{
//     margin-top: -2%;
//   }
//   .loginFrom .loginFrom-content  {
//     height: 436px;
//   }
// }

// @media screen and (max-width: 1366px) {
//   .loginFrom{
//     margin-top: -1%;
//   }
//   .loginFrom .loginFrom-content  {
//     padding: 20px 30px;
//     width: 400px;
//     height: 460px;
//   }
//   .loginFrom .headCon .text1{
//     font-size: 32px;
//     line-height: 60px;
//     margin-bottom: 0;
//   }
//   .loginFrom .headCon .text2{
//     font-size: 14px;
//     line-height: 32px;
//     margin-bottom: 20px;
//   }
//   .loginFrom .select-tenat-wrap{
//     width: 360px;
//     height: 316px;
//   }
//   .loginFrom .select-tenat-wrap .select-tenat-content{
//     padding: 20px 40px 20px;
//   }
// }
</style>
